var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0 d-flex justify-center align-center"},[_c('canvas',{style:({'width': _vm.width + 'px', 'height': _vm.height + 'px'}),attrs:{"id":_vm.graphId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }